export enum ProfileType {
  END_ENTITY = 'END_ENTITY',
  SUB_CA = 'SUB_CA',
  ROOT_CA = 'ROOT_CA',
}
